import { useState } from 'react';
import { useStore } from 'react-redux';
import { setErrors } from 'redux/slices/systemSlice';
import useAryGetState from './useAryGetState';
import { useAryMutation } from './useAryGraphql';

const useAryDelayedMutation = ({
  gqlConfig,
  type,
  onSucceed,
  onFailed,
  onPending,
  intervalTime,
  requestTimeOut
}) => {
  const reduxStore = useStore();

  const [stateId, setStateId] = useState('');
  const [loading, setLoading] = useState(false);

  const [callMutation] = useAryMutation(gqlConfig);
  useAryGetState({
    stateId,
    type,
    onSucceed: () => {
      setLoading(false);
      if (onSucceed) {
        onSucceed();
      }
    },
    onFailed: () => {
      setLoading(false);
      if (onFailed) {
        onFailed();
      }
    },
    onPending,
    intervalTime,
    requestTimeOut
  });

  const delayedMutation = async (data) => {
    setLoading(true);
    try {
      const resp = await callMutation(data);
      if (!resp.data.isDone) {
        setStateId(resp.data.stateId);
      } else {
        setLoading(false);
        if (onSucceed) {
          onSucceed(resp.data);
        }
      }
    } catch (error) {
      setLoading(false);
      reduxStore.dispatch(
        setErrors({ templateId: error.templateId, metadata: error.metadata })
      );
      if (onFailed) {
        onFailed();
      }
    }
  };

  return [delayedMutation, { loading }];
};

export default useAryDelayedMutation;
